import { Chip } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function DomainChip({ domain, onRemove }) {
    return (
        <Chip
            label={domain}
            onDelete={handleDelete}
            deleteIcon={<Iconify icon="eva:close-fill" data-cy="domain-chip-remove" />}
            size="small"
            data-cy="domain-chip"
        />
    )

    function handleDelete() {
        onRemove(domain)
    }
}
